import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import colors from "../../assets/theme-dark/base/colors";

// Modifier for tooltip positioning
const offsetModifier = [{ name: "offset", options: { offset: [0, -10] } }];

// Destructuring colors for easier reference
const { white, info } = colors;

// Default styles for the tooltip
const defaultTooltipStyles = {
  backgroundColor: white.main, // Tooltip background color
  color: "rgba(0, 0, 0, 0.87)", // Text color
  maxWidth: 220, // Max width of the tooltip
  fontSize: "0.75rem", // Font size
  border: "1.5px solid", // Tooltip border
  borderColor: info.main, // Border color
};

// JS version without interface typing
const CustomTooltip = styled(({ className, style, content, ...props }) => {
  const arrow = props.arrow ?? false;
  const placement = props.placement ?? "right";

  return (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow={arrow}
      placement={placement}
      title={content || props.title}
      slotProps={{ popper: { modifiers: offsetModifier } }}
    />
  );
})(({ style }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...defaultTooltipStyles,
    ...style,
  },
}));

export default CustomTooltip;
